import {
    post,
    get,
    del,
    put
} from './http'
export default {
    // 获取漏洞类型统计信息
    getCveType(){
        return get('/cve/statistic/cve_type_bar/')
    },

    // 获取漏洞等级统计信息
    getCveLevel(){
        return get('/cve/statistic/cve_level/')
    },

    // 获取漏洞增长统计信息
    getCveGrowth(){
        return get('/cve/statistic/cve_add/')
    }

}